import { Component, OnInit } from '@angular/core';
import {DjangoBaseUser, DjangoSessionAuthenticationService, AuthorizationData} from '../shared/';
import {Observable} from 'rxjs/Observable';
import {GeneralMessages} from '../shared/services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  user$: Observable<DjangoBaseUser>;
  loginData: AuthorizationData = {username: undefined, password: undefined};
  registerData = {};
  showRegister = false;
  showLoggedIn = false;
  showReset = false;

  constructor(private auth: DjangoSessionAuthenticationService, private messaging: GeneralMessages) {
    this.user$ =  this.auth.getUserLogged$();
  }

  ngOnInit() {
    // this.auth.getUserLogged();
  }

  login() {
    this.auth.login(this.loginData).subscribe();
  }

  logout() {
    this.auth.logout().subscribe();
  }

  forgotPassword(email) {
    this.auth.passwordReset(email).subscribe(data => this.messaging.info('Recuperar contraseña', 'Le hemos mando un correo con instrucciones para recuperar la contraseña.', 'cerrar', this.toggleRegister()));
  }

  toggleRegister() {
    this.showReset = false;
    this.showRegister = !this.showRegister;
  }

  toggleReset() {
    this.registerData = {};
    this.showReset = !this.showReset;
  }

  register() {
    var ok = this.checkLoginData(this.registerData);
    if (ok)
      this.auth.register(this.registerData).subscribe(data =>
      this.messaging.info('Cuenta creada', 'Su cuenta ha sido creada. \nDebe confirmar tu dirección de correos antes de usarla. \nSigue las instrucciones que le hemos mandado a su dirección de correo.', 'Aceptar', this.toggleReset()));
  }

  checkLoginData(data){
    console.log(data);
    if (!data.email){
      this.messaging.info('Correo incorrecto', 'Por favor, revisa la dirección de correo.');
      return false;
    }
    if (!data.password || !data.passwordRepeated || data.password != data.passwordRepeated ){
      this.messaging.info('Contraseña incorrecta', 'Por favor, revisa la contraseña que has elegido, y asegura que la has repetido correctamente.');
      return false;
    }
    if (!data.first_name || !data.last_name){
      this.messaging.info('Faltan campos', 'Por favor, introduce tu nombre y apellido.');
      return false;
    }
    if (!data.company){
      this.messaging.info('Faltan campos', 'Por favor, indica el nombre de tu empresa.');
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts